import relatorioPosicaoEstoque from './relatorioPosicaoEstoqueRepository'
import imprimirRelatorioPosicaoEstoque from './relatorioPosicaoEstoqueRepository'

export default baseUrl => {
    baseUrl = `${baseUrl}/portal-divulgacao`

    return {
        relatorioPosicaoEstoque: relatorioPosicaoEstoque(baseUrl),
        imprimirRelatorioPosicaoEstoque: imprimirRelatorioPosicaoEstoque(baseUrl),
    }
}